const defaultState = [];

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_PROJECTS':
      return action.projects;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/projects.js